import {ACTIONS} from './actions.js'

export const initialState = {
  channelsIntegrations: {},
  interactionComponent: null,
  interactionFunctionResponse: null,
  interactionParams: null,
  interactionUrl: '',
  showInteractionComponent: false,
  adsDetails: {}
}

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_INTERACTION_COMPONENT:
      return {
        ...state,
        interactionComponent: action.payload.component,
        showInteractionComponent: action.payload.show
      }
    case ACTIONS.SET_INTERACTION_FUNCTION_RESPONSE:
      return {
        ...state,
        interactionFunctionResponse: action.payload
      }

    case ACTIONS.SET_INTERACTION_INFO:
      return {
        ...state,
        interactionParams: action.payload.params,
        interactionUrl: action.payload.url
      }

    case ACTIONS.SET_CHANNELS_INTEGRATIONS:
      return {
        ...state,
        channelsIntegrations: action.payload
      }

    case ACTIONS.SET_ADS_DETAILS:
      return {
        ...state,
        adsDetails: action.payload
      }

    default:
      return state
  }
}
